const ProfileSettingsPT = {
  ProfileSettings: {
    MY_PROFILE: 'Meu perfil',
    USER_STATUS_ACTIVE: 'Ativo',
    USER_STATUS_INVITED: 'Convidado',
    USER_STATUS_BLOCKED: 'Bloqueado',
    USER_ROLE_COLABORATOR: 'Colaborador',
    USER_ROLE_ADMIN: 'Administrador',
    FIELD_REQUIRED: 'Campo obrigatório',
    LABEL_NAME: 'Nome',
    LABEL_LAST_NAME: 'Sobrenome',
    BUTTON_SAVE: 'Salvar',
    LAST_ACCESS: 'Último acesso',
    ACCESS_ACTIVE: 'Suas sessões ativas',
    CHECK_SESSIONS: 'Marque as sessões que deseja desconectar',
    DISCONNECT: 'Desconectar',
    CURRENT_SESSION: 'Sessão atual',
    DISCONNECT_SUCCESS: 'Sessão desconectada',
    CHANGE_AVATAR: 'Alterar',
  },
};

const ProfileSettingsEN = {
  ProfileSettings: {
    MY_PROFILE: 'My profile',
    USER_STATUS_ACTIVE: 'Active',
    USER_STATUS_INVITED: 'Invited',
    USER_STATUS_BLOCKED: 'Blocked',
    USER_ROLE_COLABORATOR: 'Colaborator',
    USER_ROLE_ADMIN: 'Administrator',
    FIELD_REQUIRED: 'Required field',
    LABEL_NAME: 'Name',
    LABEL_LAST_NAME: 'Last name',
    BUTTON_SAVE: 'Save',
    LAST_ACCESS: 'Last Access',
    ACCESS_ACTIVE: 'your active sessions',
    CHECK_SESSIONS: 'Check the sessions you want to disconnect',
    DISCONNECT: 'To disconnect',
    CURRENT_SESSION: 'Current session',
    DISCONNECT_SUCCESS: 'Session disconnected',
    CHANGE_AVATAR: 'Change',
  },
};

const ProfileSettingsES = {
  ProfileSettings: {
    MY_PROFILE: 'Mi perfil',
    USER_STATUS_ACTIVE: 'Activo',
    USER_STATUS_INVITED: 'Invitado',
    USER_STATUS_BLOCKED: 'Obstruido',
    USER_ROLE_COLABORATOR: 'Colaborador',
    USER_ROLE_ADMIN: 'Administrador',
    FIELD_REQUIRED: 'Campo obligatorio',
    LABEL_NAME: 'Nombre',
    LABEL_LAST_NAME: 'Apellido',
    BUTTON_SAVE: 'Salvar',
    LAST_ACCESS: 'Último acceso',
    ACCESS_ACTIVE: 'Tus sesiones activas',
    CHECK_SESSIONS: 'Consulta las sesiones que quieres desconectar',
    DISCONNECT: 'Desconectar',
    CURRENT_SESSION: 'Sesión actual',
    DISCONNECT_SUCCESS: 'Sesión desconectada',
    CHANGE_AVATAR: 'Alterar',
  },
};

export { ProfileSettingsPT, ProfileSettingsEN, ProfileSettingsES };
